<template>
    <div class="index-page">
        <PageTopBar></PageTopBar>
        <pageHeaderBar></pageHeaderBar>
        <SideBar></SideBar>
        <MenuBar pageType="Index"></MenuBar>
        <swiper class="slider" :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide v-for="(item, index) in carouselList" :key="index">
                <div class="slider-outer" :style="returnBgColor(item.backgroundColor)">
                    <div class="slider-item">
                        <a :href="item.targetUrl">
                            <img :src="item.bannerPicUrl" alt="">
                        </a>
                    </div>
                </div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
        <LoadingBar width="1200px" id="advertisementList" height="120px" v-if="advertisementListLoad"></LoadingBar>
        <div class="four-ad" v-if="!advertisementListLoad && advertisementList.length >= 4">
            <ul>
                <li v-for="(item, index) in advertisementList" v-if="index < 4">
                    <a :href="item.targetUrl">
                        <img  :src="item.advertisementPicUrl" alt="">
                    </a>
                </li>
            </ul>
        </div>
        <LoadingBar width="1200px" id="productInfoListList" height="120px" v-if="productInfoListLoad"></LoadingBar>
        <div class="floor" v-for="(item, index) in productInfoList" v-if="returnResult(index, item) && !productInfoListLoad">
            <div class="title">
                <span>{{item.fieldName}}</span>
                <!--<a href="">更多></a>-->
            </div>
            <div class="floor-content">
                <div class="left-content">
                    <a :href="item.targetUrl" v-if="item.targetUrl && item.targetUrl.length > 0">
                        <img :src="item.fieldPicUrl" v-if="item.fieldPicUrl != null && item.fieldPicUrl.length > 0" alt=""/>
                        <img :src="productDefault" v-else alt=""/>
                    </a>
                    <a v-else>
                        <img :src="item.fieldPicUrl" v-if="item.fieldPicUrl != null && item.fieldPicUrl.length > 0" alt=""/>
                        <img :src="productDefault" v-else alt=""/>
                    </a>
                </div>
                <div class="right-content">
                    <ul>
                        <li v-if="i < 3" v-for="(list, i) in item.prdList">
                            <a :href="list.targetUrl">
                                <img :src="returnImgPath(list.prdPhoto, item.imageRoot)" alt="">
                                <div class="info">
                                    <span class="p-title">{{list.prdName}}</span>
                                    <span class="p-price">￥<b>{{formatCount(list.prdPrice)}}</b></span>
                                </div>
                                <p>已售{{returnSoldNum(list.soldCount)}}</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <LoadingBar width="1200px" id="getSecAd" height="120px" v-if="getSecAdLoad"></LoadingBar>
        <div class="ad-area" v-if="!getSecAdLoad && secAdList.length > 0">
            <a v-for="(item, index) in secAdList" v-if="index == 0" :href="item.targetUrl">
                <img :src="item.advertisementPicUrl" alt="" />
            </a>
        </div>
        <LoadingBar width="1200px" id="clinicListLoad" height="120px" v-if="clinicListLoad"></LoadingBar>
        <div class="floor floor2" v-if="!clinicListLoad && clinicList.length > 0">
            <div class="title">
                <span>优质诊所</span>
                <a :href="clinicUrl">更多></a>
            </div>
            <div class="floor2-content">
                <ul>
                    <li class="first" v-if="index == 0" v-for="(item, index) in clinicList">
                        <a :href="goToDetailClinic(item.clinicId)" class="img-box">
                            <img :src="returnImgPath(item.clinicFacadeName,item.imageRootUrl, 'middle')" :onerror="defaultClinicImg"  alt="">
                        </a>
                        <div class="clinic-info">
                            <p class="clinic-name"><a href="">{{item.clinicName}}</a></p>
                            <p class="clinic-address">{{item.address}}</p>
                            <a :href="goToDetailClinic(item.clinicId)" class="view-btn">查看详情</a>
                            <a :href="goToDetailClinic(item.clinicId)" class="doctor-logo">
                                <img v-if="item.doctorPhotoPath" :src="returnDoctorLog(item.doctorPhotoPath)" :onerror="staticRoot + '/img/userlogo.png'" alt="">
                                <img v-else :src="staticRoot + '/img/userlogo.png'" :onerror="staticRoot + '/img/userlogo.png'" alt="">
                            </a>
                            <p class="doctor" v-if="item.doctorName">优质医生:{{item.doctorName}}</p>
                            <p class="doctor" v-else>优质医生</p>
                        </div>
                    </li>
                    <li v-if="index > 0 && index < 8" v-for="(item, index) in clinicList">
                        <a :href="goToDetailClinic(item.clinicId)">
                            <div class="img-box2"><img :src="returnImgPath(item.clinicFacadeName, item.imageRootUrl, 'middle')" alt=""></div>
                            <div class="clinic-info2">
                                <div class="clinic-name2">{{item.clinicName}}</div>
                                <!--<div class="clinic-type">口腔</div>-->
                            </div>
                            <div class="clinic-desc">
                                {{item.address}}
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <LoadingBar width="1200px" id="getThirdAd" height="120px" v-if="getThirdAdLoad"></LoadingBar>
        <div class="ad-area" v-if="!getThirdAdLoad && thirdAdList.length > 0">
            <a v-for="(item, index) in thirdAdList" v-if="index == 0" :href="item.targetUrl">
                <img :src="item.advertisementPicUrl" alt="" />
            </a>
        </div>
        <LoadingBar width="1200px" id="informationListLoad" height="120px" v-if="informationListLoad"></LoadingBar>
        <div class="floor floor2 floor3" v-if="!informationListLoad && informationList.length > 0">
            <div class="title">
                <span>健康资讯</span>
                <a :href="healthMore">更多></a>
            </div>
            <div class="floor2-content">
                <ul>
                    <li v-for="(item, index) in informationList"  v-if="index == 0" class="first">
                        <a :href="returnDetailHeathDetail(item.infoId)" class="img-box">
                            <img :src="item.picUrl" alt="">
                        </a>
                        <div class="article">
                            <a :href="returnDetailHeathDetail(item.infoId)">{{item.title}}</a>
                            <p class="paragraph">
                                {{item.content}}
                            </p>
                            <div class="bottom-info">
                                <div class="star">
                                    <i></i>{{item.collectionQuantity}}
                                </div>
                                <div class="eye">
                                    <i></i>{{item.readingQuantity}}
                                </div>
                                <div class="time">
                                    {{item.releaseDate}}
                                </div>
                            </div>
                        </div>
                    </li>
                    <li v-for="(item, index) in informationList"  v-if="index > 0 && index < 3">
                        <a :href="returnDetailHeathDetail(item.infoId)">
                            <div class="img-box2"><img :src="item.picUrl" alt=""></div>
                            <div class="zix-title">{{item.title}}</div>
                            <div class="bottom-info">
                                <div class="star">
                                    <i></i>{{item.collectionQuantity}}
                                </div>
                                <div class="eye">
                                    <i></i>{{item.readingQuantity}}
                                </div>
                                <div class="time">
                                    {{item.releaseDate}}
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <MsgDialog></MsgDialog>
        <FooterBar></FooterBar>
    </div>
</template>
<script>
    import {VueAwesomeSwiper,swiper, swiperSlide} from 'vue-awesome-swiper'
    import PageTopBar from './../Common/pageTopBar';
    import pageHeaderBar from './../Common/pageHeaderBar';
    import SideBar from './../Common/sideBar';
    import FooterBar from './../Common/footerBar'
    import LoadingBar from './../Utils/loadingBar';
    import MenuBar from './../Common/menuBar';
    import MsgDialog from './../Common/msgDialog';
    import axios from 'axios';
    import url from '../../../config/url';
    import common from '../../../static/js/common';
    export default {
        components:{
            PageTopBar: PageTopBar,
            LoadingBar: LoadingBar,
            SideBar: SideBar,
            pageHeaderBar:pageHeaderBar,
            FooterBar: FooterBar,
            MenuBar: MenuBar,
            swiper: swiper,
            swiperSlide: swiperSlide,
            MsgDialog: MsgDialog
        },
        data () {
            return {
                staticRoot: url.static,
                healthMore: url.commonRoot + "/health",
                productDefault : url.static + "/img/product_img.png",
                errorImg: url.static + "/img/errorImg.jpg",
                adImg: url.static + '/img/ad.jpg',
                defaultClinicImg: 'this.src="https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"',
                sliderIndex: 0,
                clinicUrl:"",
                advertisementList: [],
                advertisementListLoad: true,
                clinicListLoad: true,
                informationListLoad: true,
                productInfoListLoad: true,
                getSecAdLoad:true,
                getThirdAdLoad: true,
                carouselList: [],
                clinicList: [],
                informationList:[],
                productInfoList:[],
                secAdList:[],
                thirdAdList: [],
                swiperOption: {
                    autoplay: 3000,
                    direction: 'vertical',
                    effect : 'fade',
                    paginationClickable: true,
                    autoplayDisableOnInteraction : false,
                    fade: {
                        crossFade: true
                    },
                    pagination: '.swiper-pagination'
                }
            }
        },
        created: function () {
            this.getCarouselList();
            this.getFourAd();
            this.getSecAd();
            this.getThirdAd();
            this.getClinicInfo();
            this.getInformation();
            this.getProductInfo();
        },
        mounted: function () {
        },
        methods: {
            returnDoctorLog(logo){
                return logo.replace("http:", "");
            },
            returnResult(index, item){
                var flag = false;
                if(index == 0){// && item.prdList != null && item.prdList.length >= 3
                    if(item.fieldName != null && item.fieldPicUrl != null && item.prdList != null && item.prdList.length >= 1){
                        flag = true;
                    }
                }else{
                    if(item.prdList != null && item.prdList.length >= 1){
                        flag = true;
                    }
                }
                return flag;
            },
            returnSoldNum(num){
                if(num != null || num != "null"){
                    return num;
                }else {
                    return 0
                }
            },
            returnImgPath(path, root, type){
                if(type == "middle"){
                    if(path != null && path.length > 0){
                        return root +"middle/" +  path
                    }else{
                        return "https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"
                        //return url.static + '/img/clinicDefault.jpg'
                    }
                }else{
                    if(path != null && path.length > 0){
                        return root +  path
                    }else{
                        return "https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"
                    }
                }

            },
            formatCount(num){
                if(parseFloat(num) == "NaN"){
                    return 0
                }else{
                    var arr = num.toString().split(".");
                    if(arr.length > 1 && arr[1] > 0){
                        return num;
                    }else {
                        return parseFloat(num);
                    }
                }
            },
            returnDetailHeathDetail(id){
                return url.commonRoot + '/health/detail/' + id;
            },
            goToDetailClinic(id){
                return url.commonRoot + "/clinic/detail/" + id;
            },
            returnBgColor(color){
                return "background-color: " + color;
            },
            getFourAd(){
                var _this = this;
                var params = {
                    cityCode: window.areaId,
                    adType: 8
                };
                axios.get(url.getAdvertisement,{
                    params: params
                }).then(function (response) {
                    var res = response.data;
                    _this.advertisementListLoad = false;
                    if(res.status == "SUCCESS"){
                        _this.advertisementList = res.result;
                    }
                }).catch(function (error) {
                    _this.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            },
            getSecAd(){
                var _this = this;
                var params = {
                    cityCode: window.areaId,
                    adType: 10
                };
                axios.get(url.getAdvertisement,{
                    params: params
                }).then(function (response) {
                    var res = response.data;
                    _this.getSecAdLoad = false;
                    if(res.status == "SUCCESS"){
                        _this.secAdList = res.result;
                    }
                }).catch(function (error) {
                    _this.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            },
            getThirdAd(){
                var _this = this;
                var params = {
                    cityCode:  window.areaId,
                    adType: 11
                };
                axios.get(url.getAdvertisement,{
                    params: params
                }).then(function (response) {
                    var res = response.data;
                    _this.getThirdAdLoad = false;
                    if(res.status == "SUCCESS"){
                        _this.thirdAdList = res.result;
                    }
                }).catch(function (error) {
                    _this.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            },
            getCarouselList(){
                var _this = this;
                var params = {
                    cityCode:  window.areaId,
                };
                axios.get(url.getBannerInfo,{
                    params: params
                }).then(function (response) {
                    var res = response.data;
                    if(res.status == "SUCCESS"){
                        _this.carouselList = res.result;
                    }
                }).catch(function (error) {
                    _this.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            },
            getClinicInfo(){
                var _this = this;
                _this.clinicUrl = url.commonRoot + "/clinic/" +  window.areaPinyin;
                var params = {
                    cityCode: window.areaId,
                };
                axios.get(url.getClinicInfo,{
                    params: params
                }).then(function (response) {
                    _this.clinicListLoad = false;
                    var res = response.data;
                    if(res.status == "SUCCESS"){
                        _this.clinicList = res.result;
                    }
                }).catch(function (error) {
                    _this.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            },
            getInformation(){
                var _this = this;
                axios.get(url.getInformation).
                then(function (response) {
                    _this.informationListLoad =false;
                    if(response.data.result != null && response.data.result.length > 0){
                        _this.informationList = response.data.result;
                    }
                }).catch(function (error) {
                    _this.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            },
            getProductInfo(){
                var _this = this;
                var params = {
                    cityCode: window.areaId,
                };
                axios.get(url.getProductInfo, {
                    params: params
                }).
                then(function (response) {
                    _this.productInfoListLoad =false;
                    if(response.data.result != null && response.data.result.length > 0){
                        _this.productInfoList = response.data.result;
                    }
                }).catch(function () {
                    _this.$Message.error('数据获取失败,请稍后再试!');
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../static/scss/page/index";
</style>
<style lang="scss">
    .swiper-pagination{
        width: 958px;
    }
    .slider{
        height: 360px;
        overflow: hidden;
        position: relative;
        .swiper-slide{
            position: relative;
            z-index: 1;
        }
        .swiper-slide-active{
            z-index: 2;
        }
    }
    .swiper-pagination span {
        cursor: pointer;
        opacity: .7;
        width: 12px;
        height: 4px;
        display: inline-block;
        border-radius: 0;
        margin: 0 5px;
        background: #8391a5;
        transition: all .6s ease-in-out;
    }
    .swiper-pagination .swiper-pagination-bullet-active {
        width: 18px;
        background: #ff7013;
    }
    .swiper-pagination {
        position: absolute;
        text-align: center;
        bottom: 5px;
        z-index: 10;
        left: 50%;
        margin-left: -358px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Index/index.vue